import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from "react-redux";
import CustomAccordion from "../../common/CustomAccordion";
import H3Font from "../../common/H3Font";
import { rdFaqs } from "../data";
import styles from "./styles.module.scss";
const RDFAQ = () => {
    const goals = useSelector((state) => state.myProfile.selectedAnswers.reasons);
    const goal = goals?.find((item) => ["Build Muscle", "Gain Weight", "Lose Weight"].includes(item));
    return (_jsxs("div", { className: styles.faq, id: "rd_faqs", children: [_jsx("div", { className: styles.title, children: _jsx(H3Font, { children: "FAQ" }) }), _jsx("div", { className: styles.faq_items, children: rdFaqs.map((item) => item.text(goal) && (_jsx(CustomAccordion, { title: item.title(goal), children: _jsx("span", { className: styles.text, dangerouslySetInnerHTML: { __html: item.text(goal) } }) }, item.title(goal)))) })] }));
};
export default RDFAQ;
